import '../filter_view.js.coffee'

class Monitoring.Views.SocialContents.Filters.KeywordsFilterView extends Monitoring.Views.SocialContents.Filters.FilterView
  name: 'keywords'
  selectAll: true
  alias: 'Keyword'
  className: 'boolean-filter flex-fill'
  template: JST["backbone/templates/monitoring/filters/keywords/keywords_filter"]

  events:
    'click .open': 'onOpen'
    'click .keywords-done': 'onApply'
    'click #keywords-close': 'onClose'
    'click .one-click-open' : 'oneClickView'

  initialize: (@options = {}) ->
    super(@options)
    @groups_logic = {
      'first_group_items':    @searchQuery.get(@withPrefix('primary_keywords_logic')),
      'second_group_items':   @searchQuery.get(@withPrefix('secondary_keywords_logic')),
      'excluded_group_items': @searchQuery.get(@withPrefix('excluded_keywords_logic'))
    }
    @possible_tags = {'first_group_items': [], 'second_group_items': [], 'excluded_group_items': []}
    @selected_items = {
      'first_group_items': @withCodeAndName(@searchQuery.get(@withPrefix('primary_keywords'))),
      'second_group_items': @withCodeAndName(@searchQuery.get(@withPrefix('secondary_keywords'))),
      'excluded_group_items': @withCodeAndName(@searchQuery.get(@withPrefix('excluded_keywords')))
    }
    @validations = @options.validations || []

  withCodeAndName: (keywords) ->
    _.map(keywords, (keyword) ->
      { code: keyword, name: keyword }
    )

  getTitle: =>
    @options.title ||
      I18n.t('monitoring.dashboard.filters.filter_names.' + @name,
        {defaultValue: @alias || _.str.capitalize(@name)})

  render: ->
    [@firstGroupView, @secondGroupView, @excludedGroupView] = _.map(@viewsIds(), @viewFor)
    @$el.html(@template(title: @getTitle()))
    _.each([@firstGroupView, @secondGroupView, @excludedGroupView], (view) =>
      @$el.find('#' + view.id).replaceWith(view.render().el)
      @listenTo(view, 'added:customTag', @onAddCustomTag)
      @listenTo(view, 'removed:customTag', @onRemoveCustomTag)
    )
    _.defer @_renderTooltip
    @

  viewsIds: ->
    ['first_group_items', 'second_group_items', 'excluded_group_items']

  viewFor: (viewId) =>
    new Monitoring.Views.SocialContents.Filters.KeywordsFilterGroupView(@optionsFor(viewId))

  optionsFor: (viewId) =>
    id: viewId
    title: @titles()[viewId]
    selectedItems: @selected_items[viewId]
    logic: @groups_logic[viewId]

  titles: ->
    first_group_items: I18n.t('monitoring.dashboard.filters.keywords.main_group_keywords')
    second_group_items: I18n.t('monitoring.dashboard.filters.keywords.secondary_group_keywords')
    excluded_group_items: I18n.t('monitoring.dashboard.filters.keywords.excluded_group_keywords')

  onApply: =>
    primaryKeywords = _.pluck(@firstGroupView.selectedItems, 'code')
    secondaryKeywords = _.pluck(@secondGroupView.selectedItems, 'code')
    excludedKeywords = _.pluck(@excludedGroupView.selectedItems, 'code')

    allKeywords = _.union(primaryKeywords, secondaryKeywords, excludedKeywords)
    valid = true
    _.each(allKeywords, (keyword) =>
      _.each(@validations, (validation) ->
        unless validation.condition(keyword)
          alert(validation.message(keyword))
          valid = false
      )
    )

    return unless valid

    @searchQuery.set(@withPrefix('primary_keywords'), primaryKeywords)
    @searchQuery.set(@withPrefix('primary_keywords_logic'), @firstGroupView.logic)

    @searchQuery.set(@withPrefix('secondary_keywords'), secondaryKeywords)
    @searchQuery.set(@withPrefix('secondary_keywords_logic'), @secondGroupView.logic)

    @searchQuery.set(@withPrefix('excluded_keywords'), excludedKeywords)
    @searchQuery.set(@withPrefix('excluded_keywords_logic'), @excludedGroupView.logic)

    unless @options.blockChangeEvent
      if @options.forRule
        @trigger('changed:keywords', _.pluck(@firstGroupView.selectedItems, 'code'), _.pluck(@secondGroupView.selectedItems, 'code'), _.pluck(@excludedGroupView.selectedItems, 'code'), @firstGroupView.logic, @secondGroupView.logic, @excludedGroupView.logic)
      else
        @_triggerQueryChanged()
    @onClose()

  _triggerQueryChanged: =>
    @eventAggregator.trigger('searchQueryChanged', @searchQuery)

  onOpen: (event)->
    event.stopPropagation()
    @$el.find('#edit_keywords_modal').modal()

  withPrefix: (search_query_field) ->
    search_query_field

  onClose: ->
    @$el.find('#edit_keywords_modal').modal('hide')

  oneClickView: ->
    @$el.find('.open').click()
